import { gql } from "@apollo/client";

export const ODOO_CREATE_PRODUCT = gql`
  mutation ODOO_CREATE_PRODUCT(
    $id: ID!
    $categId: Int!
    $productType: String!
    $routes: [String]
    $reorderingRules: [ReorderingRuleInputType]
    $saleOk: Boolean!
    $purchaseOk: Boolean!
    $weight: Float
    $barCode: String
    $hsCode: String
    $createBom: Boolean
  ) {
    odooCreateProduct(
      id: $id
      categId: $categId
      productType: $productType
      routes: $routes
      reorderingRules: $reorderingRules
      saleOk: $saleOk
      purchaseOk: $purchaseOk
      weight: $weight
      barCode: $barCode
      hsCode: $hsCode
      createBom: $createBom
    ) {
      product {
        id
        odooId
      }
    }
  }
`;
